import moment from 'moment';
import { parseIntFunc } from '../utils/numberFormatFunc';
import { sortItems } from '../utils/sortFunc';
import { format1Decimal } from '../Pages/Stock/constants';

const isMobile = window.innerWidth < 850 ? true : false;
// Table 1
export const stockActiveStrikeVolumecolumns = [
  {
    title: 'Volume',
    keyName: 'volume',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'volume'),
    style: {
      headCellStyle: {
        width: '20px',
        backgroundColor: 'black',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(95, 105, 175, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ticker',
    keyName: 'usymbol',
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
      },
      bodyCellStyle: {
        padding: 0,
        width: '50px',
        minWidth: isMobile ? '58px' : '0px',
      },
    },
  },
  {
    title: 'Expiry',
    keyName: 'expiry',
    hoverClassName: true,
    hoverColor: 'white',
    func: (date) => moment(date).format('DD-MMM-YY'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'expiry'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '50px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '69px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(163, 208, 251, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Strike',
    keyName: 'strike',
    prefix: '$',
    func: (number) => number.toFixed(2),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'strike'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '40px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'P/C',
    keyName: 'put_call',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'put_call'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '40px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '7px',
      },
    },
  },
  {
    title: 'Bid%',
    keyName: 'bid_pct',
    func: (number) => (number ? `${parseIntFunc(number)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'bid_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '40px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Mid%',
    keyName: 'mid_pct',
    func: (number) => (number ? `${parseIntFunc(number)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'mid_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '40px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ask%',
    keyName: 'ask_pct',
    func: (number) => (number ? `${parseIntFunc(number)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ask_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '40px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'IV',
    keyName: 'ivol',
    func: (number) => (Math.round(number * 100 * 10) / 10).toFixed(1),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivol'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'ivolchg',
    upDown: true,
    func: (number) => (number * 100).toFixed(1),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivolchg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: '0 5px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'OI',
    keyName: 'open_int',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'open_int'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '40px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(127, 211, 210, 0.5 )',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'oichg',
    upDown: true,
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'oichg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '40px',
        },
      },
      bodyCellStyle: {
        padding: '0px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Trades',
    keyName: 'trades',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'trades'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '60px',
        textAlign: 'right',
        paddingRight: '18px',
      },
    },
  },
];

// Table 2
export const stockTopIndividualTradeColumns = [
  {
    title: 'Size',
    keyName: 'size',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'size'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        backgroundColor: 'black',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '60.5px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '68px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(95, 105, 175, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ticker',
    keyName: 'usymbol',
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '58px',
      },
    },
  },
  {
    title: 'Expiry',
    keyName: 'expiry',
    hoverClassName: true,
    hoverColor: 'white',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'expiry'),
    func: (date) => moment(date).format('DD-MMM-YY'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '50px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '70px', paddingRight: '5px' }
          : { color: 'white', width: '61px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '74px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(163, 208, 251, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Strike',
    keyName: 'strike',
    prefix: '$',
    func: (number) => number.toFixed(2),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'strike'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '58px',
        },
      },
      bodyCellStyle: {
        width: '20px',
        textAlign: 'end',
        padding: 0,
      },
    },
  },
  {
    title: 'P/C',
    keyName: 'option',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'option'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Price',
    keyName: 'price',
    prefix: '$',
    func: (number) => number.toFixed(2),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'price'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '60px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Side',
    keyName: 'mktside',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'mktside'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Stock',
    keyName: 'spot',
    func: (number) => number.toFixed(2),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'spot'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '60px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'spot_chg',
    upDown: true,
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'spot_chg'),
    func: (number) => number.toFixed(2),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Condition',
    keyName: 'condition',
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'condition'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '80px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Volume',
    keyName: 'volume',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'volume'),
    //   func:(number) =>  (number * 100).toFixed(2),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '70px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'OI',
    keyName: 'open_int',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'open_int'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '40px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(127, 211, 210, 0.5 )',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'IV',
    keyName: 'ivol',
    func: (number) => (Math.round(number * 100 * 10) / 10).toFixed(1),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivol'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '40px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'ivol_chg',
    upDown: true,
    func: (number) => (number ? (number * 100).toFixed(1) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivol_chg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: '0px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Delta',
    keyName: 'delta',
    func: (row) => (row ? row.toFixed(2) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'delta'),

    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '60px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Time',
    keyName: 'timestamp',
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'timestamp'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '40px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '60px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '60px',
        textAlign: 'end',
      },
    },
  },
];

// Stock OpenInterest Columns (Table 3)
export const stockOpenInterestcolumns = [
  {
    title: 'OI',
    keyName: 'open_int',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'open_int'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '56px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(127, 211, 210, 0.5 )',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'oichg',
    upDown: true,
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'oichg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        backgroundColor: 'black',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: '0 5px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Volume',
    keyName: 'volume',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'volume'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '60px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(95, 105, 175, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ticker',
    keyName: 'usymbol',
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
        minWidth: isMobile ? '58px' : '0px',
      },
    },
  },
  {
    title: 'Expiry',
    keyName: 'expiry',
    hoverClassName: true,
    hoverColor: 'white',
    func: (date) => moment(date).format('DD-MMM-YY'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'expiry'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '63px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(163, 208, 251, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Strike',
    keyName: 'strike',
    prefix: '$',
    func: (number) => number,
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'strike'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'P/C',
    keyName: 'put_call',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'put_call'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        width: '20px',
      },
    },
  },
  {
    title: 'Bid%',
    keyName: 'bid_pct',
    func: (number) => (number ? `${parseIntFunc(number)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'bid_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Mid%',
    keyName: 'mid_pct',
    func: (number) => (number ? `${parseIntFunc(number)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'mid_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ask%',
    keyName: 'ask_pct',
    func: (number) => (number ? `${parseIntFunc(number)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ask_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'IV',
    keyName: 'ivol',
    func: (row) => (row ? format1Decimal(row * 100) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivol'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'ivolchg',
    upDown: true,
    func: (number) => (number * 100).toFixed(2),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivolchg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: {
          paddingRight: isMobile ? '5px' : '0px',
          color: 'white',
          width: '50px',
        },
      },
      bodyCellStyle: {
        padding: '0 5px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
];



// WEBPACK FOOTER //
// ./src/constants/stockPageConstants.js